export default "__VITE_ASSET__MxWZYxj3__"